export const urls = {
  GET_ZAPOSLENI: 'Zaposleni/vrati_zaposlene',
  GET_KUPCE: 'Combo/vrati_kupce_combo',
  INSERT_ZAPOSLENI: 'Zaposleni/unos_zaposlenog',
  UPDATE_ZAPOSLENI: 'Zaposleni/izmena_zaposlenog',
  DELETE_ZAPOSLENI: 'Zaposleni/brisanje_zaposlenog',
  GET_KORISNIK_ZA_ID: 'KorisniciPrograma/vrati_korisnika_programa_za_id',
  GET_KATEGORIJE: 'Combo/vrati_kategorije_zaposlenih',
  GET_SATNICE_ERP: 'KorisniciPrograma/vrati_korisnika_programa_staro',
};
